import { render, staticRenderFns } from "./top-section2.vue?vue&type=template&id=740b1728&scoped=true&"
import script from "./top-section2.vue?vue&type=script&lang=ts&"
export * from "./top-section2.vue?vue&type=script&lang=ts&"
import style0 from "./top-section2.vue?vue&type=style&index=0&id=740b1728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b1728",
  null
  
)

export default component.exports